import {
  useNormalizer,
} from '@sttedra_ui/framework';

const {getString, getNumber} = useNormalizer();

export default class ComposeUserComposableModel {
  constructor(decodeToken) {
    // CLAVE
    this.name = getString(decodeToken?.payload?.unique_name) || null;
    this.surname = getString(decodeToken?.payload?.first_surname) || null;
    this.secondSurname = getString(decodeToken?.payload?.second_surname) || null;

    // this.surname = decodeToken?.payload?.family_name;
    // this.secondSurname = this.splitSurname(decodeToken?.payload?.family_name).secondSurname;

    this.identificationNumber = getString(decodeToken?.payload?.nameid) || null;
    this.email = getString(decodeToken?.payload?.email) || null;
    this.role = getString(decodeToken?.payload?.role) || null;
    this.nbf = getNumber(decodeToken?.payload?.nbf) || null;
    this.exp = getNumber(decodeToken?.payload?.exp) || null;
    this.iat = getNumber(decodeToken?.payload?.iat) || null;

    // CUSTOM
    this.fullName = `${this.name} ${this.surname} ${this.secondSurname}`;
    this.isNie = this.isNie();
    this.isDni = this.isDni();
  }

  isNie() {
    // eslint-disable-next-line max-len
    return this.identificationNumber?.charAt(0).toUpperCase() === 'X' || this.identificationNumber?.charAt(0).toUpperCase() === 'Y' || this.identificationNumber?.charAt(0).toUpperCase() === 'Z';
  }

  isDni() {
    return !this.isNie && this.identificationNumber;
  }

  splitSurname(value) {
    if (!getString(value)) {
      return {
        surname: null,
        secondSurname: null,
      };
    };

    const [surname, secondSurname] = value.split(' ');
    return {
      surname,
      secondSurname,
    };
  }
}
